import { getTransactionFeedbackReason, updateTransactionFeedback } from '~/api/mitra-pollings';

export const state = () => ({
  transactionFeedbackReason: [],
});
export const getters = {
  getTransactionFeedbackReason: state => state.transactionFeedbackReason || [],
};
export const mutations = {
  setTransactionFeedbackReason(state, data) {
    state.transactionFeedbackReason = data;
  },
};
export const actions = {
  async getTransactionFeedbackReason({ commit }, payload) {
    try {
      const response = await getTransactionFeedbackReason(this.$axios, payload);
      commit('setTransactionFeedbackReason', response.data);
    } catch (err) {
      // handle error
    }
  },
  updateTransactionFeedback(_context, { id, payload }) {
    return updateTransactionFeedback(this.$axios, id, payload);
  },
};
